import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { C } from '../../styles/tokens';
import { BILLING_FAQ } from '../../constants/billingFaq';

export default function BillingFAQ() {
  const [open, setOpen] = useState(null);
  return (
    <div style={{ marginBottom: 20 }}>
      <h2 style={{ fontSize: 17, fontWeight: 800, color: C.n900, marginBottom: 14, letterSpacing: '-.01em' }}>
        Frequently asked questions
      </h2>
      <div style={{ background: C.w, border: '1px solid ' + C.n200, borderRadius: 13, overflow: 'hidden' }}>
        {BILLING_FAQ.map((item, i) => {
          const isOpen = open === i;
          return (
            <div key={item.q} style={{ borderBottom: i < BILLING_FAQ.length - 1 ? '1px solid ' + C.n100 : 'none' }}>
              <button
                onClick={() => setOpen(isOpen ? null : i)}
                style={{
                  width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10,
                  padding: '14px 16px', background: 'transparent', border: 'none', cursor: 'pointer', textAlign: 'left',
                }}
              >
                <span style={{ fontSize: 13.5, fontWeight: 600, color: C.n900 }}>{item.q}</span>
                <span style={{ transform: isOpen ? 'rotate(180deg)' : 'none', transition: 'transform .15s', flexShrink: 0, display: 'flex' }}>
                  <ChevronDown size={15} color={C.n400} />
                </span>
              </button>
              {isOpen && (
                <div style={{ padding: '0 16px 16px' }}>
                  <p style={{ fontSize: 12.5, color: C.n600, lineHeight: 1.6, margin: 0 }}>{item.a}</p>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
